import {
    createContext,
    ReactNode,
    useContext,
    useEffect,
    useState,
} from "react";

import { STATE } from "../../constants/topics";
import { subscribe, buildTopicOptions, unsubscribe } from "../../services/Ros/utils/rosTopicCommands";
import { useRos } from "./utils/rosProvider";
import { Service } from "roslib";


export interface RobotStateMessage {
    data: number;
}

const RobotStateContext = createContext<string>("UNKNOWN");

export const parseRobotState = (message: RobotStateMessage): string => {
    const stateMapping: Record<number, string> = {
        0: "IDLE",
        1: "UNDOCK",
        2: "READY",
        3: "DOCKING",
        4: "AUTO",
        5: "MANUAL",
        6: "NO GPS FIX",
        7: "UNDOCK",
    };

    return stateMapping[message.data] || "UNKNOWN";
};


export const RobotStateProvider = ({
    children,
}: {
    children: ReactNode;
}) => {
    const [robotState, setRobotState] = useState<string>("UNKNOWN");
    const [service, setService] = useState<Service<any,any> | null>(null);
    const ROS = useRos();

     const callService = async (request: any) => {
            if (!service) throw new Error('Service not available');

            return new Promise((resolve, reject) => {
                service.callService(request, (result:any) => {
                    console.log('Service call succeeded:', result);
                    service.unadvertise(); // Unadvertise on success
                    resolve(result);
                }, (error:any) => {
                    console.error('Service call failed:', error);
                    service.unadvertise(); // Unadvertise on error
                    reject(error);
                });
            });
        };

    useEffect(() => {
    
        const callback = (msg: any) => {
          const stateNumber = msg as {data: number};
          setRobotState(
                        parseRobotState(
                            stateNumber,
                        )
                    );
        };

        const topic = subscribe(
            buildTopicOptions(ROS, STATE.name, STATE.type, STATE.throttle),
            callback
        );

        const rosService = new Service({
                    ros: ROS,
                    name:"/state_request_service",
                    serviceType: "std_srvs/srv/Trigger"
                });

            
        setService(rosService);

       

        return () => {
          if (topic) {
            unsubscribe(topic);
          }
          if (rosService){
            rosService.unadvertise();
          }
        };
    }, [ROS]);

    useEffect(()=> {
        if (service){
            const fetchRobotState = async () => {
                const request: any = {};

                const result = await callService(request);
                if (result.success && result.message) {
                    setRobotState(parseRobotState({data: parseInt(result.message)} as RobotStateMessage))
                    console.log(result)
                } else {
                    console.error("Service returned an unsuccessful response.");
                }
                
            };

            fetchRobotState();

        }

    },[service])

    return (
        <RobotStateContext.Provider value={robotState}>
            {children}
        </RobotStateContext.Provider>
    );
};


/*
 * Public hook
 */
export const useRobotState = (): string => {
    const context = useContext(RobotStateContext);
        if(context === undefined){
            throw new Error('useRobotState must be used in a message provider');
        }
    return context;
};